// Where the parent companion web app lives — `app.kidly.family` in production
// (a separate deployment from this TV build). The TV's pairing QR and
// add-child links must point HERE so the parent's phone opens the right app.
//
// Same principle as src/config/api.ts: default to PROD, and only use a
// localhost dev server when the build is actually being served from one. On a
// packaged TV the protocol is file:// (no http host), so it correctly falls to
// prod instead of a stale hardcoded LAN address.

const PROD_PARENT_WEB = "https://app.kidly.family";

export function parentWebOrigin(): string {
  if (
    typeof window !== "undefined" &&
    window.location &&
    (window.location.protocol === "http:" ||
      window.location.protocol === "https:")
  ) {
    const host = window.location.hostname;
    // Local dev only: the kidly web (parent) dev server runs on port 7080.
    if (host === "localhost" || host === "127.0.0.1" || host === "0.0.0.0") {
      return `http://${host}:7080`;
    }
  }
  // Real web host or packaged TV (file://) → the production parent app.
  return PROD_PARENT_WEB;
}

export function addChildUrl(): string {
  return `${parentWebOrigin()}/?action=add-child`;
}

export function pairUrl(code: string): string {
  return `${parentWebOrigin()}/?action=pair&code=${encodeURIComponent(code)}`;
}
